// views
import { Row, Col, Card } from "antd";
import UserInfoBlock from "~/components/users/UserInfoBlock";
import UserExpBlock from "~/components/users/UserExpBlock";
import UserEleBlock from "~/components/users/UserEleBlock";
import UserMuteBlock from "~/components/users/UserMuteBlock";
// report user
import SiteReportAction from "~/components/site/SiteReportAction";

const UserHeader = (props) => {
  const renderReportAction = () => {
    if (props.profile) return null;
    if (props.currentUser && props.currentUser.id == props.user.id) return null;

    return <SiteReportAction contentType={"User"} contentId={props.user.id} />;
  };

  return (
    <div className="mt-20">
      <Card>
        <div className="user-header">
          {props.user && (
            <Row type="flex" align="middle">
              <Col xs={24} sm={24} md={12}>
                <UserInfoBlock
                  user={props.user}
                  profile={props.profile}
                  showCreateTime
                />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <UserExpBlock user={props.user} profile={props.profile} />
              </Col>
              <Col xs={24} sm={12} md={4}>
                <UserEleBlock
                  user={props.user}
                  profile={props.profile}
                  onClickCharge={props.onClickCharge}
                />
              </Col>
              {/* <Col xs={24} sm={12} md={2}>
              </Col> */}
              <Col xs={24} sm={12} md={2} style={{ textAlign: "center" }}>
                <UserMuteBlock
                  user={props.user}
                  currentUser={props.currentUser}
                />

                {renderReportAction()}
              </Col>
            </Row>
          )}
        </div>
      </Card>
    </div>
  );
};

export default UserHeader;
